import type { StaticLayerPayload } from "@config";
import { IconLibrary, IconPdf } from "@library-elements/icon";
import type { ComponentType } from "react";
import { Container } from "../Container";

const Views: Record<string, ComponentType<StaticLayerPayload>> = {
  default: IconLibrary,
  pdf: IconPdf,
};

export const Icon = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={Views} />
);
